import React from 'react'

import { Intent } from '../../config/intent'

export interface FormGroupProps {
    children: React.ReactNode
    label?: string
    htmlFor?: string
    message?: string
    className?: string
    intent?: Intent
}

export function FormGroup({
    children,
    label,
    htmlFor,
    message,
    className,
    intent = Intent.DEFAULT,
}: FormGroupProps) {
    return (
        <div className={`mb-6 ${className || ''}`}>
            {label ? (
                <label htmlFor={htmlFor} className='block text-gray mb-3'>
                    {label}
                </label>
            ) : null}
            <div>
                {children}
                {message ? (
                    <div role='alert' className={`text-sm text-${intent} mt-2`}>
                        {message}
                    </div>
                ) : null}
            </div>
        </div>
    )
}
